import React, { useEffect } from 'react';
import { Container, Section, Stack } from '@fiverr-private/layout_components';
import { Typography } from '@fiverr-private/typography';
import { useIsClient } from '@fiverr-private/hooks';
import { raiseToast } from '@fiverr-private/toast';
import { getContext } from '@fiverr-private/fiverr_context';
import { BriefsTable } from '../BriefsTable';
import { AppI18n, appTranslate } from '../../i18n';
import { CreateBriefButton } from '../CreateBriefButton';
import { usePaginatedBriefsList } from '../../hooks/usePaginatedBriefsList';

export const Lobby = () => {
  const { totalCount } = usePaginatedBriefsList();
  const { queryParameters } = getContext();
  const source = queryParameters?.source;

  const isClient = useIsClient();

  useEffect(() => {
    if (isClient && source === 'delete_brief') {
      raiseToast({
        location: 'top',
        message: appTranslate('brief_deleted_toast'),
        type: 'success',
      });

      const currentPath = window.location.origin + window.location.pathname;
      window.history.replaceState({ path: currentPath }, '', currentPath);
    }
  }, [isClient, source]);

  return (
    <Section>
      <Stack direction="column" gap="8" minHeight="70vh">
        <Stack direction="row" justifyContent="spaceBetween" alignItems="center">
          <Typography as="h4" color="grey_1200">
            <AppI18n k="title" />
          </Typography>
          {!!totalCount && (
            <>
              <Container
                display={{
                  default: 'none',
                  sm: 'block',
                }}
              >
                <CreateBriefButton />
              </Container>
              <Container
                hidden={{
                  default: false,
                  sm: true,
                }}
              >
                <CreateBriefButton isIconButton />
              </Container>
            </>
          )}
        </Stack>
        <BriefsTable />
      </Stack>
    </Section>
  );
};
